export class AppointmentTime{
    constructor(
        public hour:number , 
        public minutes:number){

        }

    public toString():string{
        let prefixh = "";
        if (this.hour < 10){
            prefixh = "0";
        }
        let prefixm = "";
        if(this.minutes< 10){
            prefixm = "0";
        }

        return prefixh + this.hour + ":" + prefixm + this.minutes
    }    
}

